const initialState = {
  data: false,
};

const showOnboardingPage = (state = initialState, action) => {
  switch (action.type) {
    case "showOnboardingPage":
      return {
        ...state,

        data: action?.payload,
      };

    default:
      return state;
  }
};

export default showOnboardingPage;
